<template>
    <div class="fatcherBoX">
        <div class="titlenote">
     <!-- 111111111 -->
        <div class="NoteValue">
            <div class="oneNote">
                <span>进校短信：</span>
                <span><input type="text" v-model="FormD.enterMsg" class="resultText"></span>
            </div>
            <div class="oneNote">
                <span>出校短信：</span>
                <span><input type="text" v-model="FormD.leaveMsg"  class="resultText"></span>
            </div>
            <div class="oneNote">
                <span>异常短信：</span>
                <span><input type="text" v-model="FormD.exceptionMsg"  class="resultText"></span>
            </div>
            <div class="textValue">可用变量$studentName(学生姓名)、$teacherName(班主任姓名)、$teacherMobile(班主任电话)、$createTime(考勤时间)，
例如：您的孩子$studentName在$createTime已离开校园，如有异常请联系班主任：$teacherName(电话：$teacherMobile)。</div>
        <div class="NoteBtn">
            <el-button type="primary" size="medium" @click="setSchoolAttendance">提交</el-button>
            <el-button  type="primary"  size="medium"  @click="backClick"> 返回</el-button>
        </div>

        </div>
   </div>
    </div>
</template>
<script>
import {schoolAttendanceMsgSet} from '@/assets/api/schoollog'
import {schoolQuery} from '@/assets/api/renyuan'
export default {
   name: '',
   components: {
     
   },
   mixins: [],
   props: ['TimeObj'],
   data() {
     return {
        FormD:{
            enterMsg:'',
            exceptionMsg:'',
            leaveMsg:'',
        }
     }
   },
   computed: {
     
   },
   watch: {
     
   },
   mounted() {
    this.queryClick()
    console.log(this.TimeObj.id);
   },
   methods: {
    backClick(){
        this.$emit('schoolShowClick')
    },
    //查询短信
    queryClick(){
        const params = {
            schoolId:this.TimeObj.id,
        }
        schoolQuery(params).then((res) => {
            console.log(res);
            this.FormD.enterMsg = res.data.data.enterMsg
            this.FormD.leaveMsg = res.data.data.leaveMsg
            this.FormD.exceptionMsg = res.data.data.exceptionMsg
        }).catch((err) =>{
            // console.log(err);
            this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });

        })
    },
    //设置短信
    setSchoolAttendance(){
        const params = {
            enterMsg:this.FormD.enterMsg,
            exceptionMsg:this.FormD.exceptionMsg,
            leaveMsg:this.FormD.leaveMsg,
            schoolId:this.TimeObj.id,
        }
        schoolAttendanceMsgSet(params).then((res) => {
            // console.log(res);
            this.$message({
                    type: 'success',
                    message:'设置成功'
                });
        }).catch((err)=> {
            // console.log(err);
            this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
        })
    }

   }
};
</script>
<style lang='scss' scoped>
.fatcherBoX{
    height: 100%;
    background-color: #FFF;
    padding-top: 50px;
   
}
    .titlenote{
        margin-top: 30px;
        border: 1px solid #ccc;
        width: 80%;
        height: 40%;
        margin: 0 auto;
        .NoteValue{
            text-align: center;
            margin-top: 30px;
            .oneNote{
                margin-top: 20px;
            }

        }
        .resultText{
            border: 1px solid #000;
            width: 500px;
        }
        .textValue{
            margin-top: 20px;
        }
        .NoteBtn{
            margin-top: 20px;
        }
    }
</style>